import {
  motion,
  useScroll,
  useTransform,
} from "framer-motion";

import { useRef } from "react";
import { Link } from "react-router-dom";

import polasnap from "../asset/projects/polasnap.png";
import zylar from "../asset/projects/zylar.png";
import payforme from "../asset/projects/payforme.png";
import njs from "../asset/projects/njs.png";
import alabi from "../asset/projects/alabi.png";
import alayo from "../asset/projects/alayo.png";
import oxtech from "../asset/projects/oxtech.png";
import renik from "../asset/projects/renik.png";

const projects = [
  {
    title: "Renik Energy",
    image: renik,
    link: "https://renikenergy.com/",
  },

  {
    title: "Zylar Streetwear",
    image: zylar,
    link: "https://zylar.vercel.app/",
  },

  {
    title: "Oxtech Academy",
    image: oxtech,
    link: "https://oxtechacademy.com/",
  },

  {
    title: "NJS Royale",
    image: njs,
    link: "https://njsroyale.com/",
  },

  {
    title: "Payforme",
    image: payforme,
    link: "https://payforme.vercel.app/",
  },

  {
    title: "Alayo",
    image: alayo,
    link: "https://alayothebrand.com/",
  },

  {
    title: "ALP",
    image: alabi,
    link: "https://alabilegalpractitioners.com/",
  },

  {
    title: "Polaroid Creator",
    image: polasnap,
    link: "https://polasnap.vercel.app/",
  },
];

/* PROJECT CARD */

const ProjectCard = ({ project }) => {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "start center"],
  });

  const scale = useTransform(
    scrollYProgress,
    [0, 1],
    [0.96, 1]
  );

  const y = useTransform(
    scrollYProgress,
    [0, 1],
    [100, 0]
  );

  return (
    <motion.a
      ref={ref}
      href={project.link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        scale,
        y,
      }}
      className="
        group
        block
        sticky
        top-[80px]
        md:top-[100px]
      "
    >
      <div
        className="
          relative
          overflow-hidden
          rounded-[22px]
          md:rounded-[28px]
          lg:rounded-[34px]
          border
          border-white/10
          bg-[#1B1B1D]
          shadow-[0_20px_60px_rgba(0,0,0,0.35)]
        "
      >

        {/* IMAGE */}
        <div className="overflow-hidden">

          <img
            src={project.image}
            alt={project.title}
            className="
              w-full
              h-[240px]
              sm:h-[320px]
              md:h-[500px]
              lg:h-[700px]
              object-cover
              transition-transform
              duration-[1200ms]
              ease-out
              group-hover:scale-105
            "
          />

        </div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

        {/* CONTENT */}
        <div
          className="
            absolute
            bottom-0
            left-0
            w-full
            p-5
            sm:p-6
            md:p-8
            flex
            items-end
            justify-between
            gap-4
          "
        >

          <div>
            <h3
              className="
                text-white
                text-lg
                sm:text-xl
                md:text-2xl
                lg:text-[32px]
                font-medium
                leading-tight
              "
            >
              {project.title}
            </h3>

            <p className="mt-2 text-white/60 text-xs md:text-sm">
              View Project
            </p>
          </div>

          <div
            className="
              shrink-0
              w-11
              h-11
              md:w-14
              md:h-14
              rounded-full
              border
              border-white/20
              flex
              items-center
              justify-center
              text-white
              transition-all
              duration-300
              group-hover:bg-white
              group-hover:text-black
              group-hover:border-white
            "
          >
            →
          </div>

        </div>

      </div>
    </motion.a>
  );
};

/* MAIN */

const Projects = () => {
  return (
    <section className="py-[70px] md:py-[90px] border-b-2 border-[#7C6AE6] overflow-hidden bg-[#171718]">

      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">

        {/* HEADING */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-14 md:mb-20 text-center"
        >

      

          <h2
            className="
              text-[32px]
              sm:text-[42px]
              md:text-[48px]
              lg:text-[50px]
              uppercase
              font-semibold
              leading-[0.95]
              text-white
            "
          >
            Selected
            <span className=""> Projects</span>
          </h2>

          <p
            className="
              mt-5
              text-white/60
              text-sm
              md:text-base
              max-w-2xl
              mx-auto
              leading-relaxed
            "
          >
       A selection of products and digital experiences I’ve built across different industries.
          </p>

        </motion.div>

        {/* STACKED CARDS */}
        <div
          className="
            relative
            space-y-[-40px]
            sm:space-y-[-70px]
            md:space-y-[-120px]
          "
        >
          {projects.map((project) => (
            <ProjectCard
              key={project.title}
              project={project}
            />
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="
            mt-14
            md:mt-24
            flex
            justify-center
          "
        >
<div className="flex items-center justify
-center">
  
          <Link
            to="/project"
            className="
          inline-flex items-center uppercase  justify-center
                px-6 py-3 md:px-8 md:py-4
                text-sm md:text-base font-semibold tracking-wide
                bg-[#7C6AE6] text-white
                border-2 border-[#7C6AE6]
                hover:bg-black hover:text-[#E6D9FC]
                transition-colors duration-300
                shrink-0 rounded-md"
            
          >
            View More Projects
          </Link>
</div>

        </motion.div>

      </div>

    </section>
  );
};

export default Projects;